'use client';
import { useRef, useState } from 'react';
import { Input, type InputProps } from '@/ui-components/atoms/Inputs/Input/Input';
import { RadioLookupModal, type RadioLookupTab } from '@/ui-components/molecules/RadioLookupModal/RadioLookupModal';
import styles from './RadioIdVinInput.module.scss';

export interface RadioIdVinInputProps extends Omit<InputProps, 'type'> {
    inputRef?: { current: HTMLInputElement | null };
    lookupInitialTab?: RadioLookupTab;
    onSearchByLicensePlate?: () => void;
}

export function RadioIdVinInput({
    inputRef,
    lookupInitialTab,
    onSearchByLicensePlate,
    ...props
}: RadioIdVinInputProps): React.JSX.Element {
    const [isLookupOpen, setLookupOpen] = useState(false);
    const lookupButtonRef = useRef<HTMLButtonElement>(null);

    function handleSearchByLicensePlate() {
        onSearchByLicensePlate?.();
        setLookupOpen(false);
    }

    return (
        <>
            <div className={styles.inputField}>
                <Input
                    {...props}
                    ref={inputRef}
                    type="text"
                    noSpacing
                    radioVinId={() => setLookupOpen(true)}
                    radioVinIdExpanded={isLookupOpen}
                    radioVinIdButtonRef={lookupButtonRef}
                />
            </div>
            <RadioLookupModal
                open={isLookupOpen}
                onClose={() => setLookupOpen(false)}
                initialTab={lookupInitialTab}
                onSearchByLicensePlate={handleSearchByLicensePlate}
                restoreFocusRef={lookupButtonRef}
            />
        </>
    );
}
